import moment from "moment";
import type {InterestRegistrationRow} from "../../containers/interestLists/InterestRegistrationsColumns";
import {formatSelectedTimeSlots, statusLabel} from "../../containers/interestLists/interestListHelpers";

// CSV-Werte-Mapper für Interessens-Bekundungen (Standard-getCSVData-System,
// analog bookerValues/refundValues). Deutsch mit echten Umlauten.

const fullName = (firstname?: string | null, lastname?: string | null): string => `${firstname ?? ""} ${lastname ?? ""}`.trim();

export const interestRegistrationValues = (
    key: string,
    row: InterestRegistrationRow,
    index: number,
    _currencyShort: string,
    notExportable: string,
): string => {
    switch (key) {
        case "rowIndex":
            return `${index + 1}`;
        case "createDate":
            return row.createDate ? moment(row.createDate).format("DD.MM.YYYY HH:mm") : "";
        case "courseType":
            return row.interestList?.courseType?.name ?? "";
        case "location":
            return row.interestList?.location?.name ?? "";
        case "bookerName":
            return fullName(row.booker?.customer?.firstname, row.booker?.customer?.lastname);
        case "email":
            return row.booker?.email ?? "";
        case "phone":
            return row.booker?.mobileNumber || row.booker?.phoneNumber || "";
        case "attendeeName":
            return fullName(row.attendee?.customer?.firstname, row.attendee?.customer?.lastname);
        case "weekday":
            return formatSelectedTimeSlots(row.selectedTimeSlots ?? [], row.allTimesPossible);
        case "note":
            return row.note ?? "";
        case "status":
            return statusLabel(row.status);
        case "internalNote":
            return row.internalNote ?? "";
        default:
            return notExportable;
    }
};
